import script from "./headerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./headerSection.vue?vue&type=script&setup=true&lang=js"

import "./headerSection.vue?vue&type=style&index=0&id=6d89095f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d89095f"]])

export default __exports__